import React, { useEffect, useState } from 'react';
import { Card, Tag, Button, Select, Spin, Empty } from 'antd';
import { WarningOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';

const DAYS_OPTIONS = [
  { label: 'Son 3 gün', value: 3 },
  { label: 'Son 7 gün', value: 7 },
  { label: 'Son 14 gün', value: 14 },
  { label: 'Son 30 gün', value: 30 },
];

const MissingAttendancesPanel = () => {
  const [items, setItems]       = useState([]);
  const [days, setDays]         = useState(7);
  const [loading, setLoading]   = useState(true);
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api.get('/reports/missing-attendances', { params: { days } })
      .then(r => setItems(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [days]);

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed(c => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <WarningOutlined className="text-orange-500" />
          Eksik Yoklamalar
          {!loading && items.length > 0 && (
            <Tag color="orange" style={{ margin: 0 }}>{items.length}</Tag>
          )}
        </span>
      }
      extra={
        <Select
          size="small"
          value={days}
          onChange={setDays}
          options={DAYS_OPTIONS}
          style={{ width: 120 }}
        />
      }
    >
      {!collapsed && (loading ? (
        <div className="flex justify-center py-4"><Spin /></div>
      ) : items.length === 0 ? (
        <Empty description="Eksik yoklama yok" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <div style={{ maxHeight: 320, overflowY: 'auto' }}>
          {items.map((item) => (
            <div
              key={item.attendance_id}
              className="flex items-center justify-between py-2 border-b last:border-0 gap-2"
            >
              <div className="min-w-0">
                <span className="font-medium">{item.student_name}</span>
                <span className="text-gray-400 text-sm ml-2">— {item.classroom_name}</span>
                {item.branch_name && (
                  <span className="text-gray-300 text-xs ml-1">({item.branch_name})</span>
                )}
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs text-gray-500">
                  {dayjs(item.date).format('DD.MM')} {item.start_time}
                </span>
                <Button
                  size="small"
                  onClick={() => navigate(`/students/${item.student_id}?tab=attendance`)}
                >
                  Düzenle
                </Button>
              </div>
            </div>
          ))}
        </div>
      ))}
    </Card>
  );
};

export default MissingAttendancesPanel;
